module.exports = __webpack_public_path__ + "static/img/icon_sel_arrow.d3af9f8c.svg";